import { render, staticRenderFns } from "./iOSCourse.vue?vue&type=template&id=3bf5da1e"
import script from "./iOSCourse.vue?vue&type=script&lang=js"
export * from "./iOSCourse.vue?vue&type=script&lang=js"
import style0 from "./iOSCourse.vue?vue&type=style&index=0&id=3bf5da1e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports